import { isValid, parse } from 'date-fns';

export const getIsParsedDateValid = (value: string, format: string) =>
  isValid(parse(value, format, new Date()));
